import { initializeSharing } from "app/scripts/sharing"
import { logCustomDatadogAction, sharedVanillaSetup } from "app/scripts/shared_vanilla_setup"
import { ConnectPage } from "app/scripts/connect_page"
import TqaListTabs from "app/scripts/tqa_list_tabs"
import BuildAutomationDropdown from "app/scripts/build_automation_dropdown"
import ConnectClampedSubtitle from "app/scripts/connect_clamped_subtitle"

import "stylesheets/connect.scss"

sharedVanillaSetup()

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    logCustomDatadogAction?.("connect_service_xy_page_viewed")
    initializeSharing()
    ConnectPage()
    TqaListTabs()
    BuildAutomationDropdown()
    ConnectClampedSubtitle()
  },
  { once: true }
)
